// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mini-card-container {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 16px;
  justify-content: flex-start;
}
.mini-card-container .max-viewers {
  position: absolute !important;
  top: -30%;
}
.mini-card-container .max-viewers > div > h5 {
  width: 160px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}
.mini-card-container .max-viewers > .mini-card-container-title {
  margin-bottom: 13px;
}
.mini-card-container .mini-card-container-title {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}
.mini-card-container .mini-card-container-title .metrics-explanation {
  align-self: flex-end;
}
.mini-card-container .without-metric {
  width: calc(100% - 80px);
}
.mini-card-container {
  cursor: default;
}
.mini-card-container.hoverEffect {
  cursor: pointer;
}
.mini-card-container .content-wrapper {
  position: relative;
}
.mini-card-container .content-wrapper .right-side-line {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 40px;
}
.mini-card-container .content-wrapper .right-side-line .ListMetricVariation .variation-centered .metric-variation {
  font-weight: 600;
  font-size: 15px;
}
.mini-card-container .content-wrapper .empty-max-viewers {
  width: 110px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
}
.mini-card-container .content {
  display: flex;
  align-items: center;
}
.mini-card-container .content .right-side {
  width: 100%;
}
.mini-card-container .content .right-side .progress {
  margin-top: 6px;
}
.mini-card-container .content .left-side > div {
  margin-right: 12px;
}
.mini-card-container .gender-icon.male {
  fill: var(--color_primary_500);
}
.mini-card-container .gender-icon.female {
  fill: var(--color_primary_500);
}
.mini-card-container h2 {
  font-size: 32px;
  color: var(--base_color1);
}
.mini-card-container h2 .gender-audience-percentages {
  display: flex;
  justify-content: space-between;
  font-size: 20px;
}
.mini-card-container h2 .female {
  margin-left: 12px;
}
.mini-card-container h2 .female h6 {
  text-align: right;
}
.mini-card-container h5 {
  color: var(--gray_dark2);
}
.mini-card-container h6,
.mini-card-container span {
  color: var(--gray_dark1);
  text-transform: full-width;
  font-size: 12px;
}
.mini-card-container h6 .variation-centered,
.mini-card-container span .variation-centered {
  display: flex;
  align-items: center;
  text-transform: none;
  text-transform: initial;
}
.mini-card-container h6.subs-variation,
.mini-card-container span.subs-variation {
  margin-right: 2px;
}
.mini-card-container h6.subs-variation svg,
.mini-card-container span.subs-variation svg {
  display: block;
}
.mini-card-container h6.subs-variation-positive,
.mini-card-container span.subs-variation-positive {
  color: var(--success);
}
.mini-card-container h6.subs-variation-positive svg,
.mini-card-container span.subs-variation-positive svg {
  transform: scaleY(-1);
  fill: var(--success);
}
.mini-card-container h6.subs-variation-negative,
.mini-card-container span.subs-variation-negative {
  color: var(--danger);
}
.mini-card-container h6.subs-variation-negative svg,
.mini-card-container span.subs-variation-negative svg {
  fill: var(--danger);
}
.mini-card-container h6::first-letter,
.mini-card-container span::first-letter {
  text-transform: capitalize;
}
.mini-card-container button {
  align-self: flex-end;
  margin-bottom: 0;
  padding-bottom: 0;
  margin-right: 0;
  padding-right: 0;
}
.mini-card-container.EstimatedAudienceCard {
  grid-column: span 2;
}
.mini-card-container.EstimatedAudienceCard .content {
  display: flex;
  align-items: flex-end;
}
.mini-card-container.EstimatedAudienceCard .content .graph {
  flex-grow: 1;
}
.mini-card-container.EstimatedAudienceCard .content .progress-bar {
  min-width: 104px;
  flex-shrink: 0;
  margin-left: 36px;
}
.mini-card-container.EstimatedAudienceCard .content .progress-bar .labels,
.mini-card-container.EstimatedAudienceCard .content .progress-bar .percentages {
  display: flex;
  justify-content: space-between;
}
.mini-card-container.EstimatedAudienceCard .content .progress-bar .labels {
  margin-bottom: 12px;
}
.mini-card-container.EstimatedAudienceCard .content .progress-bar .labels > h6 {
  color: var(--base_color1);
}
.mini-card-container.EstimatedAudienceCard .content .progress-bar .labels .bullet {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.mini-card-container.EstimatedAudienceCard .content .progress-bar .ProgressBar,
.mini-card-container.EstimatedAudienceCard .content .progress-bar .ProgressBar > div {
  border-radius: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/MiniCards/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,2BAAA;AACF;AACE;EACE,6BAAA;EACA,SAAA;AACJ;AACI;EACE,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AACN;AAEI;EACE,mBAAA;AAAN;AAIE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;AAII;EACE,oBAAA;AAFN;AAME;EACE,wBAAA;AAJJ;AA9BA;EAqCE,eAAA;AAJF;AAME;EACE,eAAA;AAJJ;AAOE;EACE,kBAAA;AALJ;AAOI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AALN;AAOM;EACE,gBAAA;EACA,eAAA;AALR;AASI;EACE,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AAPN;AAWE;EACE,aAAA;EACA,mBAAA;AATJ;AAWI;EACE,WAAA;AATN;AAWM;EACE,eAAA;AATR;AAcM;EACE,kBAAA;AAZR;AAkBI;EACE,8BAAA;AAhBN;AAmBI;EACE,8BAAA;AAjBN;AAqBE;EACE,eAAA;EACA,yBAAA;AAnBJ;AAqBI;EACE,aAAA;EACA,8BAAA;EACA,eAAA;AAnBN;AAsBI;EACE,iBAAA;AApBN;AAsBM;EACE,iBAAA;AApBR;AAyBE;EACE,wBAAA;AAvBJ;AA0BE;;EAEE,wBAAA;EACA,0BAAA;EACA,eAAA;AAxBJ;AA0BI;;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EAAA,uBAAA;AAvBN;AA0BI;;EACE,iBAAA;AAvBN;AAyBM;;EACE,cAAA;AAtBR;AA0BI;;EACE,qBAAA;AAvBN;AAyBM;;EACE,qBAAA;EACA,oBAAA;AAtBR;AA0BI;;EACE,oBAAA;AAvBN;AAyBM;;EACE,mBAAA;AAtBR;AA0BI;;EACE,0BAAA;AAvBN;AA2BE;EACE,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAzBJ;AA4BE;EACE,mBAAA;AA1BJ;AA4BI;EACE,aAAA;EACA,qBAAA;AA1BN;AA4BM;EACE,YAAA;AA1BR;AA6BM;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;AA3BR;AA6BQ;;EAEE,aAAA;EACA,8BAAA;AA3BV;AA8BQ;EACE,mBAAA;AA5BV;AA8BU;EACE,yBAAA;AA5BZ;AA+BU;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AA7BZ;AAiCQ;;EAEE,gBAAA;AA/BV","sourcesContent":[".mini-card-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n  justify-content: flex-start;\n\n  .max-viewers {\n    position: absolute !important;\n    top: -30%;\n\n    > div > h5 {\n      width: 160px;\n      overflow-wrap: break-word;\n      word-wrap: break-word;\n      word-break: break-word;\n    }\n\n    > .mini-card-container-title {\n      margin-bottom: 13px;\n    }\n  }\n\n  .mini-card-container-title {\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n\n    .metrics-explanation {\n      align-self: flex-end;\n    }\n  }\n\n  .without-metric {\n    width: calc(100% - 80px);\n  }\n\n  cursor: default;\n\n  &.hoverEffect {\n    cursor: pointer;\n  }\n\n  .content-wrapper {\n    position: relative;\n\n    .right-side-line {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      height: 40px;\n\n      .ListMetricVariation .variation-centered .metric-variation {\n        font-weight: 600;\n        font-size: 15px;\n      }\n    }\n\n    .empty-max-viewers {\n      width: 110px;\n      overflow-wrap: break-word;\n      word-wrap: break-word;\n      word-break: break-word;\n    }\n  }\n\n  .content {\n    display: flex;\n    align-items: center;\n\n    .right-side {\n      width: 100%;\n\n      .progress {\n        margin-top: 6px;\n      }\n    }\n\n    .left-side {\n      & > div {\n        margin-right: 12px;\n      }\n    }\n  }\n\n  .gender-icon {\n    &.male {\n      fill: var(--color_primary_500);\n    }\n\n    &.female {\n      fill: var(--color_primary_500);\n    }\n  }\n\n  h2 {\n    font-size: 32px;\n    color: var(--base_color1);\n\n    .gender-audience-percentages {\n      display: flex;\n      justify-content: space-between;\n      font-size: 20px;\n    }\n\n    .female {\n      margin-left: 12px;\n\n      h6 {\n        text-align: right;\n      }\n    }\n  }\n\n  h5 {\n    color: var(--gray_dark2);\n  }\n\n  h6,\n  span {\n    color: var(--gray_dark1);\n    text-transform: full-width;\n    font-size: 12px;\n\n    .variation-centered {\n      display: flex;\n      align-items: center;\n      text-transform: initial;\n    }\n\n    &.subs-variation {\n      margin-right: 2px;\n\n      svg {\n        display: block;\n      }\n    }\n\n    &.subs-variation-positive {\n      color: var(--success);\n\n      svg {\n        transform: scaleY(-1);\n        fill: var(--success);\n      }\n    }\n\n    &.subs-variation-negative {\n      color: var(--danger);\n\n      svg {\n        fill: var(--danger);\n      }\n    }\n\n    &::first-letter {\n      text-transform: capitalize;\n    }\n  }\n\n  button {\n    align-self: flex-end;\n    margin-bottom: 0;\n    padding-bottom: 0;\n    margin-right: 0;\n    padding-right: 0;\n  }\n\n  &.EstimatedAudienceCard {\n    grid-column: span 2;\n\n    .content {\n      display: flex;\n      align-items: flex-end;\n\n      .graph {\n        flex-grow: 1;\n      }\n\n      .progress-bar {\n        min-width: 104px;\n        flex-shrink: 0;\n        margin-left: 36px;\n\n        .labels,\n        .percentages {\n          display: flex;\n          justify-content: space-between;\n        }\n\n        .labels {\n          margin-bottom: 12px;\n\n          > h6 {\n            color: var(--base_color1);\n          }\n\n          .bullet {\n            display: inline-block;\n            width: 8px;\n            height: 8px;\n            border-radius: 50%;\n          }\n        }\n\n        .ProgressBar,\n        .ProgressBar > div {\n          border-radius: 0;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
